<template>
  <div class="c-input">
    <input ref="input" :checked="checked" @input="updateInput($event)" class="c-input__field c-input__field-checkbox"
           :name="inputName" :id="inputName" type="checkbox" />
    <label class="c-input__label c-input__label-checkbox" :for="inputName">
      {{ $t('customField.' + config.label) }}
    </label>
  </div>
</template>

<script>
import base from './customFieldBase.vue';

export default {
  name: "customFieldBoolean",
  extends: base,
  created: function() {
    this.numeric = false
  },
  computed: {
    checked: function() {
      return this.value
    },
  },
  methods: {
    updateInput: function(e) {
      this.$emit('input', e.target.checked)
    }
  }
}
</script>

<style scoped>

</style>
